var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconExam = function SvgIconExam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.375 8a1 1 0 0 1 .894.553l2.241 4.482.02.037.74 1.48a1 1 0 1 1-1.79.895l-.473-.947H7.743l-.474.947a1 1 0 1 1-1.788-.894l.74-1.48.019-.038 2.24-4.482A1 1 0 0 1 9.376 8m.632 4.5-.632-1.264-.632 1.264z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.625 12a1 1 0 0 1 1-1h.5v-.5a1 1 0 1 1 2 0v.5h.5a1 1 0 1 1 0 2h-.5v.5a1 1 0 1 1-2 0V13h-.5a1 1 0 0 1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.513 4.013A1.75 1.75 0 0 1 3.75 3.5h16.5A1.75 1.75 0 0 1 22 5.25v15a1 1 0 0 1-1.447.894L18 19.868l-2.553 1.276a1 1 0 0 1-.894 0L12 19.868l-2.553 1.276a1 1 0 0 1-.894 0L6 19.868l-2.553 1.276A1 1 0 0 1 2 20.25v-15c0-.464.184-.91.513-1.237M4 5.5v13.132l1.553-.776a1 1 0 0 1 .894 0L9 19.132l2.553-1.276a1 1 0 0 1 .894 0L15 19.132l2.553-1.276a1 1 0 0 1 .894 0l1.553.776V5.5z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconExam;